module.exports = __webpack_public_path__ + "img/tech_devices.117e339f.png";